const Masonry = require('masonry-layout')

let masonry

export default {
  init () {
    masonry = new Masonry($('.entry-list').get(0), {
      itemSelector: '.entry-listed',
    })

    // Hover Effects
    $('body').on('mouseenter', '.entry-listed', function (event) {
      // if (typeof $(this).data('animateInDone') === 'undefined' || $(this).data('animateInDone') !== true) {
      //   return
      // }

      $(this).data('timelineHover').play()
    })

    $('body').on('mouseleave', '.entry-listed', function (event) {
      $(this).data('timelineHover').reverse()
    })
  },

  destroy () {
    if (masonry && typeof masonry === 'function') {
      masonry.destroy()
      masonry = null
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/blog.js